import { XhrError } from '@/Types/xhr-error';
import axios from 'axios';
import { toast } from 'vue3-toastify';

// // Set the base URL for all requests
// axios.defaults.baseURL = window.location.origin;

// // Set the CSRF token from the meta tag (Laravel automatically places this in your HTML)
// const csrfToken = document.head.querySelector('meta[name="csrf-token"]')?.getAttribute('content');
// if (csrfToken) {
//   axios.defaults.headers.common['X-CSRF-TOKEN'] = csrfToken;
// }

// // Automatically include cookies (session cookies for authentication)
// axios.defaults.withCredentials = true;  // This is important for session-based authentication

// If you use Vue and TypeScript, you can also add interceptors to handle responses or errors globally
axios.interceptors.response.use(
    (response) => response,
    (error) => {
        console.log('axios error', error)
        // Handle error globally (e.g., show a notification on errors)
        if(error.response){
            if(error.response.data?.props?.data?.isInertia){
                if (error.response.status === 401 || error.response.status === 419) {
                    // You can redirect to login if the user is not authenticated (status 401)
                    window.location.href = route('login');  // Change the route as needed
                }
                else{
                    return Promise.reject(error);
                }
            }
            if (error.response.status === 401 || error.response.status === 419) {
                // You can redirect to login if the user is not authenticated (status 401)
                window.location.href = route('login');  // Change the route as needed
            }
            else{
                const contentType = error.response.headers['content-type'];

                if (contentType && contentType.includes('application/json')) {
                    let returnError: XhrError = {
                        message: '',
                        msgType: 'error',
                        showErr: () => {}
                    };
                    let errObj: XhrError = error.response.data.data ?? error.response.data;
                    if(errObj.instance == "App\\Exceptions\\XhrException"){
                        returnError.message = errObj.message;
                        returnError.msgType = errObj?.msgType ?? 'error';
                        returnError.errors = {
                            [errObj.field ?? 'custom_error']: returnError.message
                        };
                    }
                    else{
                        let message: string = '';
                        let fieldErrors: { [key: string]: string } = {};
                        if(errObj.errors){
                            for (const key of Object.keys(errObj.errors)) {
                                fieldErrors[key] = errObj.errors[key][0];
                            }
                        }
                        if(Object.keys(fieldErrors).length){
                            message = Object.values(fieldErrors)[0];
                            returnError.errors = fieldErrors;
                        }
                        if(message){
                            returnError.message = message;
                        }
                    }
                    returnError.showErr = (msg?: string | null, type?: typeof returnError.msgType) => {
                        if(msg){
                            if(!type){
                                type = 'error';
                            }
                            toast[type](msg);
                        }
                        else if(returnError.message){
                            toast[returnError.msgType](returnError.message);
                        }
                    }
                    return Promise.reject(returnError);
                }

            }
        }
        return Promise.reject(error);
    }
);

export default axios;